import React from "react";
import { Box, Typography, Button, useTheme, SvgIconProps } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

interface EmptyStateProps {
  icon: React.ReactElement<SvgIconProps>;
  title: string;
  description: string;
  buttonText: string;
  onAction: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  buttonText,
  onAction,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
        textAlign: "center",
      }}
    >
      {React.cloneElement(icon, {
        sx: {
          fontSize: 80,
          color: theme.palette.grey[400],
          mb: 2,
          ...((icon.props as SvgIconProps).sx || {}),
        },
      })}
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 400 }}
      >
        {description}
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onAction}
        size="large"
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default EmptyState;
